import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { edit } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import LinkViewerURL from './link-viewer-url';
export default function LinkViewer(_ref) {
  let {
    className,
    linkClassName,
    onEditLinkClick,
    url,
    urlLabel,
    ...props
  } = _ref;
  return createElement("div", _extends({
    className: classnames('block-editor-url-popover__link-viewer', className)
  }, props), createElement(LinkViewerURL, {
    url: url,
    urlLabel: urlLabel,
    className: linkClassName
  }), onEditLinkClick && createElement(Button, {
    icon: edit,
    label: __('Edit'),
    onClick: onEditLinkClick
  }));
}
//# sourceMappingURL=link-viewer.js.map